/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowOutdoorAdventureRetreatTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowOutdoorAdventureRetreat,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Have an Outdoor Adventure!",
    "Outdoor Adventure Retreat Awaits!",
    "Explore Nature and Have Fun!",
  ],
  title: "Outdoor Adventure Retreat",
  description: "Organize a fun outdoor adventure retreat.",
  longDescription:
    "Gather your friends for an exciting outdoor adventure retreat! Choose a date, decide on activities, and plan meals!",
  emoji: "⛺",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Outdoor Adventure Retreat",
          emoji: "⛺",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the outdoor adventure retreat?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities to include?",
            description:
              "What activities should we focus on during the retreat?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🚵",
                completeAction: {
                  question: "Decide on meals?",
                  description: "What meals should we plan for the retreat?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What meals should we bring?",
                      emoji: "🍴",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Have an Adventure Together!",
    outroDescription:
      "Your outdoor adventure retreat plans are set! Enjoy the fun!",
  },
};
